export default "/images/4a02349d41813d48c040e59b32106621.avif";